import { render, staticRenderFns } from "./geo-element.vue?vue&type=template&id=268bf08a&scoped=true"
import script from "./geo-element.vue?vue&type=script&lang=js"
export * from "./geo-element.vue?vue&type=script&lang=js"
import style0 from "./geo-element.vue?vue&type=style&index=0&id=268bf08a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bf08a",
  null
  
)

export default component.exports